export const APP__GET_COMMAND_LIST__START = 'APP__GET_COMMAND_LIST__START';
export const APP__GET_COMMAND_LIST__SUCCESS = 'APP__GET_COMMAND_LIST__SUCCESS';
export const APP__GET_COMMAND_LIST__FAILURE = 'APP__GET_COMMAND_LIST__FAILURE';
export const APP__GET_MERCHANT_LIST__START = 'APP__GET_MERCHANT_LIST__START';
export const APP__GET_MERCHANT_LIST__SUCCESS = 'APP__GET_MERCHANT_LIST__SUCCESS';
export const APP__GET_MERCHANT_LIST__FAILURE = 'APP__GET_MERCHANT_LIST__FAILURE';
export const APP__RUN_COMMAND__START = 'APP__RUN_COMMAND__START';
export const APP__RUN_COMMAND__SUCCESS = 'APP__RUN_COMMAND__SUCCESS';
export const APP__RUN_COMMAND__FAILURE = 'APP__RUN_COMMAND__FAILURE';
